import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'impersonate-popup',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class ImpersondatePopup extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    // ------------------------------------------------------------------------
    // Actions
    private impersonateAccount() {
        this.$emit('onClose', false);
        this.$router.push(this.$access.landingPage);
        window.location.reload();
    }
}
